import makeSlice from '@web/slices/rewardPoint/sliceMaker'

const slice = makeSlice({})

export default slice.reducer
export const actions = slice.actions
